import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useField } from 'formik';

const FormInput = ({ label, children, InputLabelProps, icon, helperText: customHelperText, value, onChange, name, error, ...props }) => {
  // Vérifier si le composant est utilisé avec Formik (props.name existe dans props)
  const isFormik = props.name !== undefined || name !== undefined;
  
  // Utiliser useField de manière inconditionnelle
  const [field, meta] = useField(isFormik ? (props.name || name) : 'dummy-field');
  
  // Déterminer les valeurs à utiliser (Formik ou props directes)
  const inputValue = isFormik ? field.value : value;
  const handleChange = isFormik ? field.onChange : onChange;
  const inputError = isFormik ? (meta.touched && Boolean(meta.error)) : error;
  
  // Détermine le texte d'aide à afficher
  const displayHelperText = (isFormik && meta.touched && meta.error) ? meta.error : customHelperText;

  return (
    <div>
      <TextField
        fullWidth
        label={label}
        name={name}
        value={inputValue}
        onChange={handleChange}
        {...props}
        error={inputError}
        helperText={displayHelperText}
        InputLabelProps={{
          shrink: Boolean(inputValue) || props.type === 'date',
          ...InputLabelProps
        }}
        InputProps={{
          ...(icon ? {
            endAdornment: (
              <InputAdornment position="end">
                {icon}
              </InputAdornment>
            )
          } : {}),
          ...props.InputProps
        }}
      />
      {children}
    </div>
  );
};

export default FormInput;

